import {
  ITBox,
  QboCheckbox,
  QboFormGroup,
  QboModal,
  QboSpinnerProgress,
  QboTextField,
} from '@ui/Components';
import PropTypes from 'prop-types';
import React from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useToggleEnforceSSO from './pageHooks/useToggleEnforceSSO';
import useValidateEnforceSSO from './pageHooks/useValidateEnforceSSO';

function ToggleEnforceSSOModal({
  closeModal,
  showModal,
  title,
  children,
  selectedAccount,
  buttonDisabled,
}) {
  const { t } = useTranslation();
  const validation = useValidateEnforceSSO(selectedAccount);
  const { form, onValidateData, toggleEnforceSSOState } = useToggleEnforceSSO({
    selectedAccount,
    onSuccessRequest: closeModal,
  });

  const closeAndReset = () => {
    closeModal();
    form.resetForm();
    validation.reset();
  };

  return (
    <>
      {validation.validating && (
        <QboSpinnerProgress className="DefaultApplication__not-ready-loading" overlay />
      )}
      <QboModal
        onClose={closeAndReset}
        open={showModal && validation.isValid}
        title={title}
        showCloseIcon
        preventOutsideClick>
        <ITBox className="TransferSubscriptionFormPage__wrapper" direction="column">
          <QboFormGroup
            loadingButton={toggleEnforceSSOState.fetching}
            onSubmit={onValidateData}
            withGenerateAndResetButton
            handleOnResetButton={closeAndReset}
            secondButtonLabel="Cancel"
            firstButtonLabel="Submit"
            buttonDisabled={buttonDisabled}>
            {children}
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <QboTextField
                  id="supportTicket"
                  required
                  placeholder="Support Ticket"
                  label="Support Ticket"
                  fullWidth
                  value={form.attributes.supportTicketAttributes.value}
                  errorMessage={form.attributes.supportTicketAttributes.errorMessage}
                  inputProps={{ maxLength: 225 }}
                  onChange={(e) => {
                    form.attributes.supportTicketAttributes.handleChange(e.currentTarget.value);
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <QboTextField
                  id="escalationTicket"
                  placeholder="Escalation Ticket"
                  label="Escalation Ticket"
                  fullWidth
                  value={form.attributes.escalationTicketAttributes.value}
                  onChange={(e) =>
                    form.attributes.escalationTicketAttributes.handleChange(e.currentTarget.value)
                  }
                  inputProps={{ maxLength: 225 }}
                />
              </Grid>
            </Grid>

            <QboTextField
              id="description"
              placeholder="Description"
              label="Description"
              fullWidth
              value={form.attributes.descriptionAttributes.value}
              onChange={(e) =>
                form.attributes.descriptionAttributes.handleChange(e.currentTarget.value)
              }
              inputProps={{ maxLength: 225 }}
            />
            <QboCheckbox
              id="forceResetOAuth"
              label={t('user_page.toggle_enforce_sso.labels.force_reset_oauth')}
              checked={form.attributes.forceResetOAuthAttributes.value}
              onChange={(e) => {
                form.attributes.forceResetOAuthAttributes.handleChange(e.currentTarget.checked);
              }}
            />
          </QboFormGroup>
        </ITBox>
      </QboModal>
    </>
  );
}

ToggleEnforceSSOModal.propTypes = {
  closeModal: PropTypes.func,
  showModal: PropTypes.bool,
  title: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  selectedAccount: PropTypes.object,
  buttonDisabled: PropTypes.bool,
};

ToggleEnforceSSOModal.defaultProps = {
  closeModal: () => {},
  showModal: false,
  title: '',
  children: '',
  selectedAccount: null,
  buttonDisabled: false,
};

export default ToggleEnforceSSOModal;
